import React from 'react';

const MKTEXITINTENTTEMP2 = ({ formData }) => {
  // Destructure formData with default values to prevent undefined errors
  const {
    actionProps: {
      emailSubscriptionForm: {
        cssTemplateId,
        animation = '',
        background = {},
        logo = {}, // Assuming logoBanner maps to logo
        heading = {},
        subheading = {},
        overlayfields = {},
        consentMsg = {},
        confirmButton = {},
        cancelButton = {},
        image = {}, // Handle image field from example data
      } = {},
    } = {},
    exitIntentBranding,
    entityBrandingUrl,
    sourceDomain,
    poweredByIcon,
  } = formData || {};

  // Handle close button functionality
  const handleClose = () => {
    const element = document.getElementsByClassName('MKTEXITINTENTTEMP2')[0];
    if (element?.parentNode) {
      element.parentNode.removeChild(element);
    }
  };

  // Return null if the template ID doesn't match
  if (cssTemplateId !== 'MKTEXITINTENTTEMP2') return null;

  return (
    <div>
      <div className="MKTEXITINTENTTEMP2">
        <div className={`mkt-animated ${animation}`} id="MKTEXITINTENTTEMP2">
          <div
            className="full-page-exit-intent-mkt"
            style={{
              background: background?.color,
              borderColor: background?.color,
            }}
          >
            <div id="exit-intent-template">
              {/* Image (conditionally rendered based on image.show) */}
              {image?.show && (
                <img
                  id="ft-exit-intent-image"
                  src={image?.url || `${process.env.REACT_APP_API_ENDPOINT}/assets/img/emptyImage.jpg`}
                  alt="Template Image"
                  style={{ textAlign: image?.position }}
                />
              )}

              {/* Close Button */}
              {cancelButton?.show && (
                <a
                  className="mkt-close-exit-intent mkt-close-2-icon cancel-button"
                  id="close-frame"
                  onClick={handleClose}
                />
              )}

              <div className="exit-intent-template language-handler">
                <div id="exit-intent-template3">
                  {/* Logo (conditionally rendered based on logo.show) */}
                  {logo?.show && (
                    <div
                      className="mkt-logo-container"
                      style={{ textAlign: logo?.position || 'center' }}
                    >
                      <img src={logo?.url} alt="Logo" />
                    </div>
                  )}

                  {/* Heading (conditionally rendered based on heading.show) */}
                  {heading?.show && (
                    <div className="exit-intent-title">
                      <span
                        dangerouslySetInnerHTML={{ __html: heading?.text }}
                        style={{
                          lineHeight: 'normal !important',
                          fontSize: heading?.fontsize,
                          color: heading?.color,
                        }}
                      />
                    </div>
                  )}

                  {/* Subheading (conditionally rendered based on subheading.show) */}
                  {subheading?.show && (
                    <div className="exit-intent-desc">
                      <span
                        dangerouslySetInnerHTML={{ __html: subheading?.text }}
                        style={{
                          lineHeight: 'normal !important',
                          fontSize: subheading?.fontsize,
                          color: subheading?.color,
                        }}
                      />
                    </div>
                  )}

                  {/* Form Inputs (conditionally rendered based on overlayfields.show) */}
                  {(overlayfields?.show?.length > 0 || overlayfields?.email || overlayfields?.phone) && (
                    <div className="template-inputs">
                      <form autoComplete="off" id="ft_exit_intent_template_form">
                        {overlayfields?.show?.includes('email') && overlayfields?.email && (
                          <>
                            <input
                              id="ftExitIntentEmailField"
                              name="email"
                              placeholder="Enter email address"
                              style={{
                                width: '90%',
                                border: '1px solid #e4e4e4',
                                color: '#666666',
                              }}
                              type="email"
                            />
                            <span className="exitintent-error-block" />
                          </>
                        )}
                        {overlayfields?.show?.includes('phone') && overlayfields?.phone && (
                          <>
                            <input
                              id="ftExitIntentPhoneField"
                              name="phone"
                              placeholder="Enter phone number"
                              style={{
                                width: '90%',
                                border: '1px solid #e4e4e4',
                                color: '#666666',
                              }}
                              type="text"
                            />
                            <span className="exitintent-error-block" />
                          </>
                        )}
                      </form>
                    </div>
                  )}

                  {/* Consent Message (conditionally rendered based on consentMsg.show) */}
                  {consentMsg?.show && consentMsg?.status && (
                    <p
                      className="mkt-consent-text"
                      dangerouslySetInnerHTML={{ __html: consentMsg?.text }}
                      style={{
                        color: `${consentMsg?.color} !important`,
                        lineHeight: 'normal !important',
                        fontSize: `${consentMsg?.fontsize || 'inherit'} !important`,
                        marginTop: '5px',
                        padding: 0,
                      }}
                    />
                  )}

                  {/* Confirm Button (conditionally rendered based on confirmButton.show) */}
                  {confirmButton?.show && (
                    <button
                      className="submit"
                      id="ft_exit_intent_template_submit"
                      style={{ background: confirmButton?.background?.color }}
                      type="submit"
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: confirmButton?.text || confirmButton?.text }}
                        style={{ color: confirmButton?.content?.color || confirmButton?.color }}
                      />
                    </button>
                  )}

                  {/* Cancel Button (conditionally rendered based on cancelButton.show) */}
                  {cancelButton?.show && (
                    <div
                      className="mkt-close-link cancel-button"
                      id="close-link"
                      style={{ background: cancelButton?.background?.color }}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: cancelButton?.text || cancelButton?.text }}
                        onClick={handleClose} // Fixed: Use handleClose instead of inline logic
                        style={{ color: cancelButton?.content?.color || cancelButton?.color }}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Branding Footer */}
              {exitIntentBranding && (
                <div
                  style={{
                    width: '100%',
                    padding: '10px 0px',
                    textAlign: 'center',
                    position: 'absolute',
                    bottom: '-44px',
                    filter: 'brightness(100)',
                  }}
                >
                  <a
                    className="dialog-branding-text"
                    href={`${entityBrandingUrl}?utm_source=${sourceDomain}&utm_medium=exitintent&utm_campaign=poweredby`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Powered by
                    <img
                      style={{ width: 'auto', height: '15px', marginLeft: '10px' }}
                      src={poweredByIcon}
                      alt="Powered by"
                    />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MKTEXITINTENTTEMP2;